import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

function ChatInput({ onSend, disabled = false }) {
  const [input, setInput] = useState('');
  const textareaRef = useRef(null);

  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 120) + 'px';
    }
  }, [input]);

  const handleSend = () => {
    if (input.trim() && !disabled) {
      onSend(input.trim());
      setInput('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevent default Enter behavior
      handleSend();
    }
    // Shift+Enter will naturally create a new line in textarea
  };

  return (
    <div className="input-container" style={{
      display: 'flex',
      alignItems: 'center',
      background: 'white',
      borderRadius: '25px',
      padding: '0.5rem 1rem',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      border: '1px solid var(--color-border)',
      margin: '1rem 0 0 0'
    }}>
      <textarea
        ref={textareaRef}
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Ask a question"
        className="input-field"
        rows={1}
        style={{ 
          flex: 1,
          border: 'none',
          outline: 'none',
          padding: '0.75rem',
          fontSize: '15px',
          background: 'transparent',
          color: '#000',
          resize: 'none',
          minHeight: '20px',
          maxHeight: '120px',
          overflow: 'auto',
          fontFamily: 'inherit'
        }}
      />
      <button
        onClick={handleSend}
        disabled={disabled || !input.trim()}
        className="send-button"
        style={{ 
          background: disabled || !input.trim() ? '#ccc' : 'var(--color-secondary)',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: disabled || !input.trim() ? 'not-allowed' : 'pointer',
          transition: 'background 0.2s'
        }}
      >
        →
      </button>
    </div>
  );
}

ChatInput.propTypes = {
  onSend: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ChatInput; 